import React from 'react';
import { Card, FlexRow, Header1Text, NavigationItem, Breadcrumbs } from 'ui-toolkit';
import { clientNavigationOptions } from '../../router/admin/ClientLenderCompaniesRouter';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';

interface IClientDetailsHeaderProps {
  companyName?: string | null;
  clientId: string;
  currentPageLink: string;
}

export const ClientDetailsHeader: React.FC<IClientDetailsHeaderProps> = ({
  companyName,
  clientId,
  currentPageLink,
}) => (
  <>
    <Breadcrumbs
      homeLink={ClientUrlFactory().urlFor.adminOrders()}
      links={[
        {
          to: ClientUrlFactory().urlFor.clientCompaniesIndex(),
          text: 'Clients',
        },
        {
          to: clientNavigationOptions(clientId)[0].to,
          text: companyName || '',
        },
      ]}
    />
    <Card>
      <Header1Text>{companyName}</Header1Text>
      <FlexRow>
        {clientNavigationOptions(clientId).map((nav) => (
          <NavigationItem {...nav} isActive={currentPageLink === nav.to} />
        ))}
      </FlexRow>
    </Card>
  </>
);
